import React, { useEffect, useState } from 'react';
import './FundHoldings.css';

// Top holdings for an ETF / mutual fund. Fetches the public, cached holdings
// endpoint (reuses the in-production ETF-holdings source) and renders a compact
// weighted list. Renders nothing when holdings aren't available, so it can be
// dropped into any ETF/fund view safely.
export default function FundHoldings({ ticker }) {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetch(`/api/public/holdings/${encodeURIComponent(ticker)}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('no holdings'))))
      .then((d) => { if (!cancelled) setRows(d.holdings || []); })
      .catch(() => { if (!cancelled) setRows([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [ticker]);

  if (loading || !rows || rows.length === 0) return null;

  const max = Math.max(...rows.map((r) => r.weight_pct || 0), 1);

  return (
    <div className="fundhold">
      <div className="fundhold-title">Top holdings</div>
      <div className="fundhold-list">
        {rows.map((r, i) => (
          <div className="fundhold-row" key={r.symbol || i}>
            <span className="fundhold-sym">{r.symbol}</span>
            <span className="fundhold-name">{r.name || ''}</span>
            <span className="fundhold-track">
              <span className="fundhold-fill" style={{ width: `${((r.weight_pct || 0) / max) * 100}%` }} />
            </span>
            <span className="fundhold-w">{r.weight_pct != null ? `${r.weight_pct.toFixed(1)}%` : '—'}</span>
          </div>
        ))}
      </div>
      <div className="fundhold-foot">Top {rows.length} positions by weight · a fund is only as good as what it holds.</div>
    </div>
  );
}
